/**
 * @generated SignedSource<<31eaeabb130e97c8acf72df2b2215aef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetCourseOptions_CourseBucket$data = {
  readonly slotDurations: ReadonlyArray<{
    readonly maxDurationMins: number;
    readonly startSlot: {
      readonly course: {
        readonly description: string | null | undefined;
        readonly id: string;
        readonly name: string;
      };
      readonly id: string;
    };
  } | null | undefined>;
  readonly " $fragmentType": "useGetCourseOptions_CourseBucket";
};
export type useGetCourseOptions_CourseBucket$key = {
  readonly " $data"?: useGetCourseOptions_CourseBucket$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetCourseOptions_CourseBucket">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "agendaId"
    },
    {
      "kind": "RootArgument",
      "name": "startTime"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetCourseOptions_CourseBucket",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "agendaId",
          "variableName": "agendaId"
        },
        {
          "kind": "Variable",
          "name": "startsAt",
          "variableName": "startTime"
        }
      ],
      "concreteType": "SlotDurations",
      "kind": "LinkedField",
      "name": "slotDurations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxDurationMins",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CourseBucket",
  "abstractKey": null
};
})();

(node as any).hash = "56d50d410a324ce19c5b19148326ee3a";

export default node;
